import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QualificationTrainingProviderType } from '@wilson/interfaces';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { QualificationTrainingProviderTagComponent } from '../../qualification-training-provider-tag/qualification-training-provider-tag.component';

@Component({
  selector: 'wilson-qualification-training-provider-renderer',
  template: `
    <wilson-qualification-training-provider-tag [provider]="providerData" />
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [QualificationTrainingProviderTagComponent],
})
export class QualificationTrainingProviderRendererComponent
  implements AgRendererComponent
{
  public providerData!: {
    name: string;
    providerType: QualificationTrainingProviderType;
  };

  agInit(params: ICellRendererParams): void {
    this.setProviderData(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setProviderData(params);
    return true;
  }

  setProviderData(params: ICellRendererParams): void {
    this.providerData = {
      name:
        params.data?.organizationalUnitQualificationTrainingProvider
          ?.qualificationTrainingProvider?.name || '',
      providerType:
        params.data?.organizationalUnitQualificationTrainingProvider
          ?.qualificationTrainingProvider?.providerType ||
        QualificationTrainingProviderType.Manual,
    };
  }
}
